export function pickEnum<T extends string>(
  members: readonly T[],
  raw: string | null | undefined,
  fallback: T,
): T {
  return (members as readonly string[]).includes(raw ?? '') ? (raw as T) : fallback;
}
